function RmList() {
    return (
      <div className="App">
        <header className="App-header">
          <p>
           This is the RM list page
          </p>
        </header>
      </div>
    );
  }
  
  export default RmList;